import { useNavigate } from "react-router-dom";
import LogoImage from "../../assets/icons/Logo 2.webp";
import { useLanguage } from "../../contexts/LanguageContext";

const SubscriptionModal = ({ isOpen, onClose, previewCount }) => {
  const navigate = useNavigate();
    const { translations } = useLanguage();

    const Headline =
      translations.subscriptionModal?.Headline || "Get Full Access";
    const SubText =
      translations.subscriptionModal?.SubText ||
      "Access full tracks, playlists, DJ edits & exclusive producer packs — everything you need as a DJ.";
    const Button =
      translations.subscriptionModal?.Button || "Unlock Full Access";
    const SubLine = translations.subscriptionModal?.SubLine || "Cancel anytime";


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-6">
      <div
        className="absolute inset-0 bg-black/75 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative w-full max-w-lg bg-gradient-to-br from-[#03060a] to-[#071018] rounded-xl shadow-2xl border border-cyan-700/20 p-8">
        {/* Close */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 w-8 h-8 rounded-full bg-black/30 flex items-center justify-center hover:bg-black/40 transition"
        >
          <svg
            className="w-4 h-4 text-gray-300"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div className="flex flex-col items-center text-center">
          <img
            src={LogoImage}
            alt="Logo"
            className="w-24 h-24 object-contain mb-6"
          />

          <h2 className="text-3xl font-extrabold text-white mb-6">
            {Headline}
          </h2>

          <p className="text-gray-300 max-w-[520px] mb-6"> {SubText}</p>

          <button
            onClick={() => {
              onClose();
              navigate("/membership");
            }}
            className="mt-2 w-[260px] py-3 px-6 bg-gradient-to-r from-cyan-400 to-blue-500 text-black font-semibold rounded-full shadow-lg hover:opacity-95 transition mb-2"
          >
            {Button}
          </button>
          <p className="text-gray-300 text-sm"> {SubLine}</p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionModal;
